export const themeContext = Symbol("wx-theme");
//# sourceMappingURL=index.js.map